// hooks/useClientsByUser.ts
import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface ClientRow {
  id: number;
  initials: string;
  utilization: string;
  authDetails: string;
  ratio: string;
}

export const useClientsByUser = (
  username?: string,
  enabled: boolean = true
) => {
  const client = useMyProviderDataClient();
  const [data, setData] = useState<ClientRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !username) return;

    const load = async () => {
      setLoading(true);

      const res = await client.get(
        "/EmployeeInformation/ClientsByUser",
        { params: { username } }
      );

      const clients = res.data;

      // 🚀 Parallel fetch utilization for each client
      const enriched = await Promise.all(
        clients.map(async (c: any) => {
          const util = await client.get(
            "/EmployeeInformation/ClientUtilization",
            { params: { clientid: c.clientID } }
          );

          const utilData = util.data[0];

          const name = c.clientName.split(",");
          const initials =
            name[1].trim().substring(0, 2) +
            name[0].trim().substring(0, 2);

          return {
            id: c.clientID,
            initials,
            utilization:
              utilData?.["Total Hours Used Percentage"]?.toFixed(0) + "%" || "0%",
            authDetails:
              utilData?.["Hours Possible to Fill"]?.toFixed(0) + " hrs" || "No Hours",
            ratio: "—",
          };
        })
      );

      setData(enriched);
      setLoading(false);
    };

    load();
  }, [username, enabled, client]);

  return { data, loading };
};